export default __webpack_public_path__ + "static/media/presentation.52dbd759.pptx";